import { shape } from 'prop-types';
import { useEffect, useState } from 'react';
import moment from 'moment';
import ClockGif from 'Assets/images/commons/clock.gif';

import CountUpNumber from '../CountUpNumber/CountUpNumber';

import css from './Counter.less';

const INTERVAL = 1000;

const calculateDuration = (sessionStartTime, initialChargingDuration) => {
  const duration = moment.duration(moment() - moment.utc(sessionStartTime).valueOf());
  const second = duration.asSeconds() - initialChargingDuration;
  return Math.round(second);
};

const convertSecond2Minute = second => {
  return Math.ceil(second / 60);
};

function Counter({ room }) {
  const [duration, setDuration] = useState(0);

  const { initialChargingDuration, sessionStartTime } = room;

  useEffect(() => {
    const startCountTime = -calculateDuration(sessionStartTime, initialChargingDuration) * 1000;

    let interval = null;

    const timeout = setTimeout(() => {
      interval = setInterval(() => {
        const second = calculateDuration(sessionStartTime, initialChargingDuration);
        if (second > 0) setDuration(second);
      }, INTERVAL);
    }, startCountTime);

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [sessionStartTime, initialChargingDuration]);

  return (
    <div className={css.container}>
      <img src={ClockGif} alt="clock" />
      <CountUpNumber value={duration} />
      <div>
        <span> </span>
        {convertSecond2Minute(duration) > 1 ? 'mins' : 'min'}
      </div>
    </div>
  );
}

Counter.propTypes = {
  room: shape({}).isRequired,
};

export default Counter;
